/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { SrcEntrypointProps } from './ui/UpgradeModalSrc.entrypoint.types.tsx';

type EntryPointPremiumUpgradeModalComponent = EntryPointComponent<{}, {}, SrcEntrypointProps, {}>;

export const entryPointPremiumUpgradeModal: EntryPoint<EntryPointPremiumUpgradeModalComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<EntryPointPremiumUpgradeModalComponent>(
			/* webpackChunkName: "entryPoint-premium-upgrade-modal" */ './ui/index.tsx',
		),
		getPreloadProps: () => ({}),
	});
